// 用户中心-积分管理页面
import request from '@/utils/request'
import qs from 'qs'

// 获取实验室企业列表
export const getAllLaboratorys = (params) => {
  return request({
    url: '/api/dept/labs',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

// 编辑实验室
export const editLaboratory = (data) => {
  return request({
    url: '/api/dept/lab',
    method: 'PUT',
    data: data,
  })
}

// 修改实验室启用状态
export const modifyLaboratoryCanOrder = (id) => {
  return request({
    url: `/api/dept/labEnable/${id}`,
    method: 'PUT',
  })
}

// 获取实验室详情
export const getLaboratorydDetails = (id) => {
  return request({
    url: `/api/dept/lab/${id}`,
    method: 'GET',
  })
}

// 更改实验室排序: {id, sort}
export const laboratorySort = (data) => {
  return request({
    url: '/api/dept/labSort',
    method: 'PUT',
    data: data,
  })
}